import React, { Component } from 'react'
import PropTypes from 'prop-types'
import TextInput from 'atoms/TextInput'
import FieldLayout from '../FieldLayout'

export default class ProposalNameEditor extends Component {
  static propTypes = {
    proposal: PropTypes.object.isRequired,
    onProposalUpdate: PropTypes.func.isRequired,
  }

  handleSave = (name) => {
    const { onProposalUpdate } = this.props
    onProposalUpdate({ name })
  }

  render() {
    const { proposal } = this.props
    return (
      <FieldLayout title="What">
        <TextInput
          required
          maxLength={128}
          multiline
          enableLineBreak
          placeholder="Start typing..."
          defaultValue={proposal.name || ''}
          onSave={this.handleSave}
        />
      </FieldLayout>
    )
  }
}
